var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140.33,
    height: 138.238,
    viewBox: "0 0 140.33 138.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ac,.af,.aj,.ak,.al,.am,.ao,.aq,.as,.b,.n,.o,.z{fill:none;}.a{stroke:#cac8c8;}.a,.aa,.ab,.ac,.af,.aj,.ak,.al,.am,.ao,.b,.o,.p,.q,.z{stroke-miterlimit:10;}.a,.b{stroke-width:0.89px;}.b{stroke:#adadad;}.c{fill:#b8b6b6;}.d{fill:#1450ff;}.e{fill:url(#a);}.aa,.ab,.ar,.f,.p{fill:#fff;}.g{fill:#f2f2f2;}.h{fill:url(#b);}.i{fill:url(#c);}.j{fill:#fcfcfc;}.k{fill:#fafbfc;}.l{fill:url(#d);}.m{fill:url(#e);}.af,.ak,.aq,.as,.n{stroke:#fff;}.al,.aq,.as,.n,.o,.p,.q{stroke-linecap:round;}.aq,.as,.n{stroke-linejoin:round;}.n{stroke-width:0.36px;}.ab,.aj,.o,.p,.q,.z{stroke:#ffb000;}.o,.p,.q,.z{stroke-width:2.37px;}.q{fill:#f0e1d4;}.r{fill:#374486;}.s{fill:#fab6ad;}.t{fill:#3f4d90;}.u{fill:#383c4d;}.v{fill:#b37361;}.w{fill:#41465a;}.x{fill:#49549a;}.y{fill:#ffcfc9;}.aa,.ac,.ao{stroke:#6562cf;}.aa,.ao,.as{stroke-width:2px;}.ab,.ac,.aj,.ak{stroke-width:2.11px;}.ad{fill:#3f4d79;}.ae{fill:#6562cf;}.af{stroke-width:1.5px;}.ag{fill:#eaeeff;}.ah{fill:#ffc0b7;}.ai{fill:#ffb000;}.al{stroke:#ffb0af;stroke-width:1.26px;}.am{stroke:#000;stroke-width:0.42px;}.an{fill:#e2e2ff;}.ap{fill:#d8d8d8;}.ar{font-size:1px;font-family:Arial-BoldMT, Arial;font-weight:700;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.006,
    y1: 0.498,
    x2: 0.997,
    y2: 0.498,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.002,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.006,
    y1: 0.502,
    x2: 1.001,
    y2: 0.502,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -0.007,
    y1: 0.504,
    x2: 1,
    y2: 0.504,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.445 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74.481,
    height: 48.996,
    transform: "translate(0 8.95)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 74.465,
    transform: "translate(0 11.553)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 22.387,
    height: 22.385,
    transform: "translate(5.411 15.923)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 34.219,
    transform: "translate(32.089 17.895)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 34.219,
    transform: "translate(32.089 21.272)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 34.219,
    transform: "translate(32.089 24.648)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 34.219,
    transform: "translate(32.089 28.024)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M165.406,252.1,159.3,262.654h12.2Z",
    transform: "translate(-148.793 -230.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 0.631,
    cy: 0.631,
    rx: 0.631,
    ry: 0.631,
    transform: "translate(0.978 9.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(3.171 9.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(5.348 9.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 33.367,
    height: 51.67,
    transform: "translate(57.647 31.526)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 30.458,
    transform: "translate(68.795 60.849)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 30.458,
    transform: "translate(68.795 64.225)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.724,
    cy: 8.724,
    r: 8.724,
    transform: "translate(65.615 37.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M300.347,415.662l2.114-1.862H300.3Z",
    transform: "translate(-267.548 -366.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 16.329,
    height: 7.18,
    rx: 3.59,
    transform: "translate(30.685 40.377)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(36.034 43.343)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(38.227 43.343)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(40.404 43.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M758.914,428.977,756.8,427.1h2.161Z",
    transform: "translate(-648.705 -379.867)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 16.329,
    height: 7.18,
    rx: 3.59,
    transform: "translate(95.994 40.276)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(105.712 43.226)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(103.535 43.226)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(101.342 43.226)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 0.978,
    cy: 0.978,
    r: 0.978,
    transform: "translate(84.895 30.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 0.978,
    cy: 0.978,
    r: 0.978,
    transform: "translate(90.669 33.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M7301.729,7195.7a6.97,6.97,0,0,1-1.277-3.6",
    transform: "translate(-7211.708 -7114.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M7249.4,7214.2c1.482.11,3.344.173,4.654,1.073",
    transform: "translate(-7168.719 -7132.741)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.345 80.497)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M6861.639,7382.8l9.828,10.585a4.575,4.575,0,0,1,1.767,3.63v11.153a2.556,2.556,0,0,1-2.556,2.557H6857.9",
    transform: "translate(-6842.328 -7355.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M6790.075,7233.975h0a1.675,1.675,0,0,1-1.673,1.688h-24.28a4.937,4.937,0,0,1-4.922-4.938V7211.46a3.379,3.379,0,0,1,3.361-3.361h12.464a2.3,2.3,0,0,1,2.3,2.3h0v16.96a4.9,4.9,0,0,0,4.922,4.923h6.154a1.673,1.673,0,0,1,1.673,1.689Z",
    transform: "translate(-6759.199 -7208.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M6790.012,7236.383a1.688,1.688,0,0,1-1.609,1.215h-24.28a4.937,4.937,0,0,1-4.922-4.938V7213.4a3.376,3.376,0,0,1,1.847-3,3.416,3.416,0,0,0-.537,1.814v20.021a4.18,4.18,0,0,0,4.182,4.18h25.02Z",
    transform: "translate(-6759.199 -7210.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M6874.5,7288.5h4.607a8.091,8.091,0,0,1,8.076,8.093v5.6",
    transform: "translate(-6856.31 -7275.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M6794.139,7382.8l9.828,10.585a4.58,4.58,0,0,1,1.768,3.63v11.153a2.556,2.556,0,0,1-2.556,2.557H6790.4",
    transform: "translate(-6785.478 -7355.238)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.311 67.679)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M6879.982,7126.878s4.591-.678,7.368,5.365c2.413,5.285,4.212,10.223,4.212,10.223a73.18,73.18,0,0,0,10.018,4.324v3s-9.577.552-12.763,0c-2.351-.41-8.835-9.1-9.277-15S6879.982,7126.878,6879.982,7126.878Z",
    transform: "translate(-6879.417 -7126.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M7010.944,7256.033c-.362-.081-.1-1.185.11-1.862a1.2,1.2,0,0,1,.758-.727,5.379,5.379,0,0,1,2.7-.348,3.946,3.946,0,0,1,2.367,1.453c.189.221,1.1,1.263,1.1,1.545Z",
    transform: "translate(-6990.043 -7233.132)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M6799.023,7111.152c-3.977.41-11.628,5.223-10.365,22.909.82,11.295,8.235,16.975,9.134,16.581s16.124-7.889,12.637-11.929-2.257-6.815-1.735-12.037,1.325-10.917-2.919-12.889C6798.9,7110.6,6800.081,7111.042,6799.023,7111.152Z",
    transform: "translate(-6780.548 -7045.88)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.697 90.607)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.248 1.383)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.449 38.849)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M6998.555,7556.589h-10.839c-.016-.172-.016-.33-.016-.487h10.869A2.5,2.5,0,0,1,6998.555,7556.589Z",
    transform: "translate(-6987.7 -7551.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M6988.905,7527.2c.031,1.23-1.1,2-1.1,4.56h10.838a2.533,2.533,0,0,0-2-2.635c-2.162-.487-4.149-1.15-4.338-1.925Z",
    transform: "translate(-6987.785 -7527.199)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M6862.654,7281.056s16.55-1.089,20.573,3.85-3.786,24.358-4.575,35.039a24.108,24.108,0,0,1-5.569,0c-1.609-.41-3.014-21.124,1.042-26.142,0,0-14.783,3.692-20.794-.962S6860.146,7281.135,6862.654,7281.056Z",
    transform: "translate(-6851.744 -7280.954)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.309 26.626)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M7164.145,7448.426l-8.614,6.895c-.125-.158-.221-.315-.331-.457l8.568-6.863A2.507,2.507,0,0,1,7164.145,7448.426Z",
    transform: "translate(-7153.386 -7446.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M7143.7,7444.622c.756.945.3,2.3,1.8,4.322l8.6-6.878a2.4,2.4,0,0,0-3.139-.821c-2.02.979-3.944,1.721-4.56,1.23Z",
    transform: "translate(-7143.701 -7440.954)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M6843.922,7285.945c.253,1.405,13.71,5.4,28.7-4.48,0,0,2.319,13.032,17.464,21.662,0,0,3.329-1.483,4.244-3.472,0,0-10.681-13.662-14.482-24.722-1.609-4.638-21.694-2.207-24.644-1.262S6842.818,7279.746,6843.922,7285.945Z",
    transform: "translate(-6843.833 -7272.187)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.354 69.526)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M6821.276,7138.839c3.455,1.152,8.345,11.407,8.345,11.407a52.268,52.268,0,0,1,13.727,3.992,5.125,5.125,0,0,1-.9,3.265s-9.088,1.184-13.82.694c-1.594-.159-7.651-4.7-11-10.964C6814.666,7141.616,6817.033,7137.435,6821.276,7138.839Z",
    transform: "translate(-6816.308 -7138.565)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.477 14.722)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M6984.634,7232.878s2.3-1.214,3.376-.961a5.562,5.562,0,0,1,2.508,1.482,12.749,12.749,0,0,1,1.089,1.893c0,.3-3.061.19-3.486.19s-3.251.031-3.8-.079S6984.634,7232.878,6984.634,7232.878Z",
    transform: "translate(-6984.135 -7231.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M7008.811,7235.665c.426,0,3.487.11,3.487-.188a11.581,11.581,0,0,0-1.088-1.895,5.445,5.445,0,0,0-2.509-1.482,3.2,3.2,0,0,1,.11,3.565",
    transform: "translate(-7004.825 -7232.066)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M6857.637,7076.1c.063.536-1.136,3.234-3.266,5.349-1.893,1.845,6.2,3.266,6.405,3.218a21.7,21.7,0,0,0,1.356-3.55C6862.337,7080.455,6857.637,7076.1,6857.637,7076.1Z",
    transform: "translate(-6835.771 -7016.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M6881.417,7081.623c-.079.283-.411,1.231-.772,2.193a6.064,6.064,0,0,1-2.762-2.872,11.953,11.953,0,0,1-.883-3.991.717.717,0,0,1,.047-.253C6877.757,7077.364,6881.607,7081.023,6881.417,7081.623Z",
    transform: "translate(-6855.07 -7016.935)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M6883.55,7051.488c.331,1.341.63,3.6.173,4.686s-1.262,3.108-1.578,3.2-3.818-.347-4.623-1.861a9.558,9.558,0,0,1-.946-3.234c-.113-.458,1.8-4.165,4.228-4.086S6883.454,7051.109,6883.55,7051.488Z",
    transform: "translate(-6854.71 -6994.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M6863.663,7031.9c-.646.268-.157,1.009-1.373,1.136s-1.482-1.389-1.482-1.389a1.2,1.2,0,0,1-.758.8s.333-.631-.141-.915a.554.554,0,0,0-.742.094.456.456,0,0,0-.63.285c-.222.489.173.773.694.835,0,0,.047.711-1.1.821s-1.373-.584-1.373-.584-.19-.173-.269.331.315,1.309-.489,1.957a2.222,2.222,0,0,1-.583.378c.395.347.2,1.4-.711,1.829-1.23.584-2.145.159-2.255-.694s.394-.472.269-1.073a.876.876,0,0,1-1.325-.267c-.521-.869.315-1.136.315-1.136s-.521-.727-.1-1.232,1.279-.2,1.168-.567-.411-1.2.078-1.672,1.247-.284,1.357-.536-.047-.63-.552-.411a1.2,1.2,0,0,1,.5-.8,2.064,2.064,0,0,1,1.562-.095,1.523,1.523,0,0,1,.757-1.136,1.369,1.369,0,0,1,1.72.489.776.776,0,0,1,.646-.521c.963-.143,1.767.11,1.957.9s1.625-1.073,2.3.552c.142.331-.221.583.188.852s.536-.347.3-.521a1.467,1.467,0,0,1,.694.615A1.19,1.19,0,0,1,6863.663,7031.9Z",
    transform: "translate(-6833.357 -6975.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M6767.5,7288.5h5.6a8.092,8.092,0,0,1,8.078,8.093v5.6",
    transform: "translate(-6762.847 -7195.321)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.014 89.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M6986.6,7266.5h-32.1a.9.9,0,0,0-.9.9h0a.906.906,0,0,0,.26.646.894.894,0,0,0,.64.27h32.1Z",
    transform: "translate(-6953.598 -7266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M6986.6,7266.5h-32.1a.9.9,0,0,0-.9.9h0a.906.906,0,0,0,.26.646.894.894,0,0,0,.64.27h32.1",
    transform: "translate(-6953.598 -7266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M7074.7,7323.767l5.191-43.432a.851.851,0,0,1,1.672-.032l6.47,43.212",
    transform: "translate(-7055.594 -7277.557)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.274 75.274)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa",
    width: 25.921,
    height: 1.592,
    rx: 0.796,
    transform: "translate(0 12.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M7034.541,7187.728h-18.1a.612.612,0,0,1-.536-.26.621.621,0,0,1-.064-.591l5.112-10.87a1.845,1.845,0,0,1,1.673-1.01h18.1a.614.614,0,0,1,.6.852l-5.111,10.87A1.847,1.847,0,0,1,7034.541,7187.728Z",
    transform: "translate(-7010.245 -7174.996)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.487 52.959)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.784 51.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M7422.126,7362.441a1.341,1.341,0,0,1-1.326,1.325h-20.683a1.341,1.341,0,0,1,0-2.666H7420.8A1.343,1.343,0,0,1,7422.126,7362.441Z",
    transform: "translate(-7398.922 -7361.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M7452.608,7380.145h-7.776a.929.929,0,0,1-.932-.945V7378h9.655v1.2A.946.946,0,0,1,7452.608,7380.145Z",
    transform: "translate(-7436.804 -7375.335)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    width: 2.035,
    height: 16.302,
    transform: "translate(10.914 4.812)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    width: 3.928,
    height: 4.204,
    rx: 1.964,
    transform: "translate(9.952 21.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M7435.417,7525.386a3.787,3.787,0,0,0-3.787-3.786h-10.442a3.769,3.769,0,0,0-3.787,3.786",
    transform: "translate(-7414.485 -7496.278)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 1.515,
    cy: 1.515,
    r: 1.515,
    transform: "translate(19.496 28.051)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 1.515,
    cy: 1.515,
    r: 1.515,
    transform: "translate(1.306 28.051)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 1.515,
    cy: 1.515,
    r: 1.515,
    transform: "translate(10.472 28.051)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.736)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 34.448)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M7317.8,7507.9c-.678,1.609-1.293,2.919-1.767,3.786s-.962,4.387-4.165,2.888c-.11-.062,1.263-.41,1.7-3.518.143-1.089.284-2.131.411-3.14A37.974,37.974,0,0,0,7317.8,7507.9Z",
    transform: "translate(-7309.546 -7467.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M7304.758,7532s1.278-4.466-.441-5.144c-.552-.222-1.216.331-1.389,2.208-.158,1.641-2.557,1.91-2.793.837,0,0-2.935.6-2.935,2.1Z",
    transform: "translate(-7297.201 -7483.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M7314.463,7292.241a34.977,34.977,0,0,1-5.442-.017s-2.479-25.952-2.115-28.618c.442-3.219,11.14-6.059,16.676-6.957l1.011-4.623s7.478-.125,11.706-.125c0,0,4.528,8.045,4.055,13.362s-10.224,4.117-23.239,4.117C7317.114,7269.381,7321.09,7277.4,7314.463,7292.241Z",
    transform: "translate(-7305.344 -7251.901)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.675 6.874)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M7406.451,7508.532a14.615,14.615,0,0,1-2.98-.031c.33,1.293.646,2.54.883,3.645.157.693-.853,1.656-1.152,2.351h.032c1.325-.206,3.107,1.056,2.934-.915S7406.262,7511.1,7406.451,7508.532Z",
    transform: "translate(-7397.153 -7474.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M7397.7,7531.4c.457,0,1.2.837,1.136,2.162a7.688,7.688,0,0,1-.489,2.3l-5.145,0a2.81,2.81,0,0,1,1.611-2.1c1.325-.205,3.045,1.058,2.855-.915Z",
    transform: "translate(-7388.729 -7494.178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M7378.847,7295.837s-11.328,2.05-12.62,5.44,4.716,27.657,4.716,27.657a13.563,13.563,0,0,0,5.27,0c3.63-16.612-.615-22.134-.615-22.134,8.44-.348,13.772.441,14.594-4.828C7390.459,7300.286,7388.565,7293.879,7378.847,7295.837Z",
    transform: "translate(-7365.859 -7295.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M7377.667,7297.8s-11.345,2.051-12.621,5.444,4.716,27.655,4.716,27.655",
    transform: "translate(-7364.868 -7297.431)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.235 14.035)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M7401.479,7139.3c.678-1.53-2.319-3.533-5.381-2.729,0,0,1.026-12.29,3.456-13.836s2.9,5.57,2.981,7.3C7402.536,7130.039,7402.978,7136.713,7401.479,7139.3Z",
    transform: "translate(-7380.731 -7122.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M7319.17,7213.645c1.482-1.326-1.578-4.04-5.111-3.093-2.209.348-10.808,2.178-11.612,2.587a25.821,25.821,0,0,0-3.359,1.845,4.065,4.065,0,0,0-.395,1.752c.016.142.33.962.33.962a.571.571,0,0,0,.4-.237.559.559,0,0,0,.088-.457c-.078-.741.585-.978,1.025-1.167.189-.08.663-.049.743.221s-.616.63-.727.835a1.127,1.127,0,0,0,.031.647l1.278-.678a6.266,6.266,0,0,0,1.451-2.051S7316.568,7216,7319.17,7213.645Z",
    transform: "translate(-7298.691 -7196.497)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.531)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M7415.2,7041.2c-.251-.6-1.276-3.738.4-5.1s3.881-2.744,6.548-2.523,3.423,3.771,4.938,4.354,3.361-.11,5.111,1.451-.078,4.039,1.7,5.364,3.5-.348,5.286,1.988c2.034,2.666-.947,5.759,1.956,6.026,3.2.284,5.144,5.711,3.77,9.324h-16.706C7417.523,7060.427,7415.2,7041.2,7415.2,7041.2Z",
    transform: "translate(-7414.663 -7033.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M7425.4,7036.313a8.268,8.268,0,0,1,6.2-2.272c2.683.126,3.707,3.124,5.238,3.661s3.471-.221,5.253,1.325.079,4.307,1.894,5.6,3.486-.474,5.347,1.862c2.131,2.666-.74,5.71,2.163,5.884,3.219.2,5.315,4.259,3.707,8.882",
    transform: "translate(-7423.705 -7033.954)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.944 12.723)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M7402.21,7136s-.946-7.714-1.452-8.123a3.73,3.73,0,0,1-1.546-4.007c.268-1.011,2.4-7.747,2.854-8.174a22.39,22.39,0,0,1,3.456-1.5h8.44c.962.314,3.975,1.4,4.7,2.508,3.533,5.411,4.654,14.057,4.654,14.057h-4.386s-2.114-4.733-2.855-4.781-2.162,9.956-2.162,9.956A28.292,28.292,0,0,1,7402.21,7136Z",
    transform: "translate(-7398.953 -7114.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M7401.455,7187.3s-.947-7.714-1.452-8.124a3.89,3.89,0,0,1-1.625-4.071",
    transform: "translate(-7398.261 -7165.493)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M7440,7120.2s-3.881,7.417-2.918,21.536",
    transform: "translate(-7430.829 -7119.252)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ak",
    cx: 0.521,
    cy: 0.521,
    r: 0.521,
    transform: "translate(7.823 6.752) rotate(-80.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ak",
    cx: 0.521,
    cy: 0.521,
    r: 0.521,
    transform: "translate(7.124 10.516) rotate(-80.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ak",
    cx: 0.521,
    cy: 0.521,
    r: 0.521,
    transform: "translate(7.121 13.726)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.629 28.011)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M7425.793,7214.491c-2.161,2.272-16.2-.773-16.2-.773s-.726,1.151-1.578,1.2-1.672-.27-2.114.109-.868.995-1.215,1.074a4.082,4.082,0,0,1-1.23.046c.158-.41.315-.789.506-1.184-.253.222-.584.6-.759.759a.474.474,0,0,1-.6.046s.569-.851.79-1.088a4.564,4.564,0,0,1,1.275-.932,28.869,28.869,0,0,1,4.354-1.688c1.311-.221,12.544-.961,12.544-.961C7425.6,7211.1,7427.623,7212.567,7425.793,7214.491Z",
    transform: "translate(-7402.602 -7211.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M7410.7,7230.747a8.881,8.881,0,0,1,1.071-1.545l1.1-.6",
    transform: "translate(-7409.423 -7225.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M7414.2,7231.911a7.444,7.444,0,0,1,.993-1.31l1.09-.6",
    transform: "translate(-7412.372 -7227.02)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.497 7.549)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M7443.224,7081.4a9.022,9.022,0,0,0,5.031,5.175s-5.395,2.351-8.455,0V7081.5Z",
    transform: "translate(-7439.8 -7081.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M7440.673,7087.064a4.2,4.2,0,0,1-.772-.488V7081.5l3.406-.095a2.218,2.218,0,0,1,.11.284C7443.765,7083.231,7442.819,7086.466,7440.673,7087.064Z",
    transform: "translate(-7439.884 -7081.4)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M7424.471,7060.912c-.048,1.2-2.319,4.055-3.565,4.055s-2.966-3.108-3.2-4.528,0-4.007,2.066-4.039c1.263-.017,1.926,1.167,2.3,2.556a1.566,1.566,0,0,0,1.893,1.309s.41-.93.979-.474S7424.471,7060.912,7424.471,7060.912Z",
    transform: "translate(-7398.629 -7052.795)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.147 35.126)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M605.7,731.015l3.329-45.815,3.329,45.91",
    transform: "translate(-605.4 -683.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7249.1,7258.268h43.8a1.026,1.026,0,0,0,1.024-1.026h0a1.04,1.04,0,0,0-1.024-1.041h-43.8Z",
    transform: "translate(-7249.1 -7256.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M7249.1,7258.268h43.8a1.026,1.026,0,0,0,1.024-1.026h0a1.04,1.04,0,0,0-1.024-1.041h-43.8",
    transform: "translate(-7249.1 -7256.201)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.555)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M7258.285,7157.5h-17.669a1.216,1.216,0,0,0-1.215,1.215,1.18,1.18,0,0,0,.079.411l4.448,12.116h20.7l-4.606-12.527A1.864,1.864,0,0,0,7258.285,7157.5Z",
    transform: "translate(-7238.784 -7157.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7259.058,7157.5h-17.749a1.245,1.245,0,0,0-1.1,1.689l3.864,11.2a1.216,1.216,0,0,0,1.137.852h19.829l-4.29-12.479A1.816,1.816,0,0,0,7259.058,7157.5Z",
    transform: "translate(-7239.398 -7157.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M7254.406,7162.8h-17.732a1.168,1.168,0,0,0-1.1,1.594l3.864,10.523a1.2,1.2,0,0,0,1.121.788H7260.4l-4.291-11.722A1.832,1.832,0,0,0,7254.406,7162.8Z",
    transform: "translate(-7235.489 -7161.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M7267.8,7244.6h33.855a1.783,1.783,0,0,1,1.782,1.766h-33.855a1.784,1.784,0,0,1-1.782-1.769Z",
    transform: "translate(-7262.704 -7230.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M7258.285,7157.5h-17.669a1.216,1.216,0,0,0-1.215,1.215,1.18,1.18,0,0,0,.079.411l4.448,12.116h20.7l-4.606-12.527A1.864,1.864,0,0,0,7258.285,7157.5Z",
    transform: "translate(-7238.784 -7157.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ai",
    cx: 1.136,
    cy: 1.404,
    rx: 1.136,
    ry: 1.404,
    transform: "translate(10.137 7.773) rotate(-48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ac",
    cx: 1.136,
    cy: 1.404,
    rx: 1.136,
    ry: 1.404,
    transform: "translate(10.553 7.357) rotate(-48)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "ap",
    width: 12.472,
    height: 8.209,
    rx: 2,
    transform: "translate(119.811 12.077)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aq",
    x2: 5.857,
    y2: 3.859,
    transform: "translate(120.19 12.941)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aq",
    x1: 6.236,
    y2: 4.117,
    transform: "translate(126.047 12.682)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.792,
    cy: 1.792,
    rx: 1.792,
    ry: 1.792,
    transform: "translate(130.561 10.355)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ar",
    transform: "translate(131.696 11.792)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7311.409,6837.4h0a1.011,1.011,0,0,1,1,1.009v3.44a.993.993,0,0,1-.994.993h0a1.008,1.008,0,0,1-1.009-.994v-3.439A1.01,1.01,0,0,1,7311.409,6837.4Z",
    transform: "translate(-7209.573 -6817.049)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 2.004,
    cy: 2.004,
    r: 2.004,
    transform: "translate(99.833 27.593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7284.543,6857.7a6.027,6.027,0,0,0-6.042,6.042h12.085A6.043,6.043,0,0,0,7284.543,6857.7Z",
    transform: "translate(-7182.708 -6834.145)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "as",
    y1: 21.914,
    transform: "translate(101.837)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMobileIcon);
export default __webpack_public_path__ + "static/media/dashboard-mobile-icon.02a7c10e8917ae783b6cb7af3ed79c7b.svg";
export { ForwardRef as ReactComponent };